/* eslint-disable no-empty */
import { UsersWithProfilePicsExtractChannel } from '@tableau/omnibox-common/lib/src/channelDefinitions/UsersWithProfilePicsExtractChannel'
import axios, { AxiosRequestConfig } from 'axios';
import { getSessionManagementServiceInstance, SessionManagementService } from './SessionManagementService';
import { ContentDefinitions } from '../models/ContentDefinitions';
import { ContentSuggestionData, ContentSuggestionDataItem } from '../models/Types';
import { OmniboxConfigurationService } from '../OmniboxConfigurationService';

export type ownerInCRASSData = { content: { ownerId: string, ownerName: string } };

export class SearchService {
    public static readonly instance = new SearchService();
    private server: SessionManagementService;
    public initialize() {
        this.server = getSessionManagementServiceInstance();
    }

    public get Server(): SessionManagementService {
        return this.server;
    }

    public usersWithProfilePictures(ids: string[]) {
        const channel = new UsersWithProfilePicsExtractChannel();
        return channel.call(ids).data?.usersWithProfilePics;
    }

    public async getContentSuggestions(searchTerm: string): Promise<ContentSuggestionDataItem[]> {
        const availabeContentTypeKeys = OmniboxConfigurationService.instance.configuration.requiredContentTypes.map(contentType => {
            return ContentDefinitions[contentType].shouldBeAvailable() ? contentType : null;
        }).filter(item => item !== null);

        const parameters = [`terms=${searchTerm}`];
        parameters.push(`filter=type:in:[${availabeContentTypeKeys.join(',')}]`);

        const response = await axios.get(OmniboxConfigurationService.instance.configuration.apiHost + `/content-exploration/suggestions?${parameters.join('&')}`, this.getAxiosConfig());
        const data = response.data as ContentSuggestionData;
        return data?.hits?.items;
    }

    public async getEmptyContentSuggestions(): Promise<ContentSuggestionDataItem[]> {
        const availabeContentTypeKeys = OmniboxConfigurationService.instance.configuration.requiredContentTypes.map(contentType => {
            return ContentDefinitions[contentType].shouldBeAvailable() ? contentType : null;
        }).filter(item => item !== null);

        const parameters: string[] = [];
        parameters.push('page=0');
        if (OmniboxConfigurationService.instance.configuration.emptyStateContentSuggestionFetchLimit){
            parameters.push(`limit=${OmniboxConfigurationService.instance.configuration.emptyStateContentSuggestionFetchLimit}`);
        }else{
            parameters.push('limit=20');
        }
        parameters.push(`filter=type:in:[${availabeContentTypeKeys.join(',')}]`);

        const response = await axios.get(OmniboxConfigurationService.instance.configuration.apiHost + `/content-exploration/search?${parameters.join('&')}`, this.getAxiosConfig());
        const data = response.data as ContentSuggestionData;
        return data?.hits?.items;
    }

    public async getRelatedOwners(): Promise<ownerInCRASSData[]> {
        const availabeContentTypeKeys = OmniboxConfigurationService.instance.configuration.requiredContentTypes.map(contentType => {
            return ContentDefinitions[contentType].shouldBeAvailable() ? contentType : null;
        }).filter(item => item !== null);

        const parameters = [];
        parameters.push(`filter=type:in:[${availabeContentTypeKeys.join(',')}]`);
        parameters.push('limit=50');

        const response = await axios.get(OmniboxConfigurationService.instance.configuration.apiHost + `/content-exploration/search?${parameters.join('&')}`, this.getAxiosConfig());
        return response.data?.hits?.items || [];
    }

    public async personalizationRefresh() {
        try {
            await axios.post(OmniboxConfigurationService.instance.configuration.apiHost + '/content-exploration/personalization/refresh', null, this.getAxiosConfig());
        } catch {
        }
    }

    private getAxiosConfig(): AxiosRequestConfig {
        const config: AxiosRequestConfig = { headers: {} };

        if (OmniboxConfigurationService.instance.configuration.xsrfToken) {
            config.headers['X-XSRF-TOKEN'] = OmniboxConfigurationService.instance.configuration.xsrfToken;
            config.headers['WithCredentials'] = true;
        }

        return config;
    }
}